"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountClassification = void 0;
var AccountClassification;
(function (AccountClassification) {
    AccountClassification["ASSET"] = "Asset";
    AccountClassification["EQUITY"] = "Equity";
    AccountClassification["EXPENSE"] = "Expense";
    AccountClassification["LIABILITY"] = "Liability";
    AccountClassification["REVENUE"] = "Revenue";
})(AccountClassification || (exports.AccountClassification = AccountClassification = {}));
